export const notListedInputFieldHasError = (
  data: any,
  field: string,
  hotToast
) => {
  const value = data?.[field];
  if (typeof value !== "string" || !value.includes("not-listed")) {
    return false;
  }
  const fieldText = data[`${field}Text`];
  if (fieldText === undefined || fieldText === "") {
    hotToast.error(
      `If you check Not Listed for the ${field} field, you should fill the input besides it.`
    );
    return true;
  }
  return false;
};

export const updateFieldNotListedForSubmission = (
  notListedFieldValue: string,
  notListedFieldTextValue: string
) => {
  if (typeof notListedFieldValue !== "string" || !notListedFieldValue) {
    return notListedFieldValue ?? "";
  }
  return notListedFieldValue.includes("not-listed")
    ? `not-listed: ${notListedFieldTextValue}`
    : notListedFieldValue;
};

export const updateFieldNotListedFromData = (
  notListedField: string,
  notListedFieldValue: string
) => {
  if (typeof notListedFieldValue !== "string" || !notListedFieldValue) {
    return {
      [notListedField]: notListedFieldValue ?? "",
      [`${notListedField}Text`]: undefined,
    };
  }
  if (notListedFieldValue.includes("not-listed")) {
    return {
      [notListedField]: "not-listed",
      [`${notListedField}Text`]: notListedFieldValue
        .replace("not-listed: ", "")
        .trim(),
    };
  }

  return {
    [notListedField]: notListedFieldValue,
    [`${notListedField}Text`]: undefined,
  };
};
